import React from "react";
import { getComparisonReport } from "../services/comparisonReportService";

// Drives the Comparison Report panel: one GET across all three optimization
// pipelines against a shared baseline. Kept separate from useOptimizationData.js /
// useRlOptimizationData.js / useBprRedesignData.js — this is a read-only summary
// over those three, not a fourth thing to run/save. State is lifted to the page
// (like rl/bpr) so the last report survives switching away from this tab.
export default function useComparisonReportData() {
  const [result, setResult] = React.useState(null);
  const [running, setRunning] = React.useState(false);
  const [runError, setRunError] = React.useState("");

  const seqRef = React.useRef(0);

  const run = React.useCallback(async (processId, opts) => {
    if (!processId) return;
    const seq = ++seqRef.current;
    setRunning(true);
    setRunError("");
    setResult(null);
    try {
      const data = await getComparisonReport(processId, opts);
      if (seq !== seqRef.current) return;
      setResult(data);
    } catch (e) {
      if (seq !== seqRef.current) return;
      setRunError(e?.message || "Comparison report failed");
    } finally {
      if (seq === seqRef.current) setRunning(false);
    }
  }, []);

  const reset = React.useCallback(() => {
    seqRef.current += 1;
    setResult(null);
    setRunning(false);
    setRunError("");
  }, []);

  return {
    result,
    running,
    runError,
    run,
    reset,
  };
}
